import React from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getItemType } from './itemTypes';

const ConsoleItemReader = ({
  item,
  onBack,
  onEdit,
  onDelete,
  onAddListItem,
  onEditListItem,
  onDeleteListItem
}) => {
  const type = getItemType(item.itemType);
  const { Viewer } = type;
  const count = type.count?.(item);

  return (
    <article className="overflow-hidden rounded-lg border border-gray-700/70 bg-gray-900/70 shadow-lg">
      <header className="flex flex-wrap items-start justify-between gap-3 border-b border-gray-700/70 p-4 sm:p-5">
        <div className="min-w-0">
          <button
            type="button"
            onClick={onBack}
            className="mb-2 inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white lg:hidden"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            All items
          </button>
          <h3 className="break-words text-xl font-bold sm:text-2xl">{item.displayName}</h3>
          <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-gray-400">
            <span className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 font-medium ${type.badgeClass}`}>
              <FontAwesomeIcon icon={type.icon} />
              {type.label}
              {count !== undefined && ` · ${count} ${count === 1 ? 'item' : 'items'}`}
            </span>
            {item.updatedAt && (
              <span title={moment(item.updatedAt).format('LLL')}>
                Updated {moment(item.updatedAt).fromNow()}
              </span>
            )}
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={() => onEdit(item)}
            className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            <FontAwesomeIcon icon={faEdit} />
            Edit
          </button>
          <button
            type="button"
            onClick={() => onDelete(item._id)}
            title="Delete item"
            aria-label="Delete item"
            className="rounded-md bg-gray-700 px-3 py-2 text-sm text-gray-200 hover:bg-red-600 hover:text-white"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      </header>

      <div className="p-4 sm:p-6">
        <Viewer
          item={item}
          onAddListItem={onAddListItem}
          onEditListItem={onEditListItem}
          onDeleteListItem={onDeleteListItem}
        />
      </div>
    </article>
  );
};

export default ConsoleItemReader;
